import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Grid, Typography, Box } from '@mui/material'
import { Formik } from 'formik'
import React from 'react'
import { StorageInstallationStatementModel } from '../../models'
import StorageForm from './StorageForm'
import { buildLabelWithRequiredPrefix } from 'src/Libs/form'
import { useStorageValidation } from '../../hooks/validation'
import { FormStepProps } from 'src/Libs/installation-statement/components/types'

/**
 * Component to handle form data of the step storage
 */
const Storage: React.FC<FormStepProps<StorageInstallationStatementModel>> = ({ data, setFormData, setFinalValidation, setTouched }) => {
  const { t } = useCustomTranslation()
  const { inProgressValidationSchema, finalValidationSchema } = useStorageValidation()

  const handleValidationForFinalValidationSchema = async (values: StorageInstallationStatementModel): Promise<void> => {
    const response = await finalValidationSchema.isValid(values)
    setFinalValidation(response)
  }

  return (
    <Grid container sx={{ flexDirection: 'column' }} spacing={0}>
      <Typography variant="h4">{t('installation-statement.storage.title')}</Typography>
      {/*eslint-disable-next-line @typescript-eslint/no-empty-function*/}
      <Formik initialValues={data} validationSchema={inProgressValidationSchema} onSubmit={() => {}} validateOnMount>
        {formData => {
          if (formData.dirty) {
            setTouched(true)
          }

          setFormData(formData)

          handleValidationForFinalValidationSchema(formData.values)
          return <StorageForm />
        }}
      </Formik>
      <Box sx={{ display: 'flex', justifyContent: 'end', marginTop: 2 }}>
        <Typography variant="caption">{buildLabelWithRequiredPrefix(t('common.required'))}</Typography>
      </Box>
    </Grid>
  )
}

export default Storage
